export enum ACTION_RESULT {
  NONE,
  LOADING,
  SUCCESS,
  ERROR,
}
